var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 25,
  viewBox: "0 0 25 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M19.9 1H2c-.5 0-1 .5-1 1v11.3c0 .6.5 1 1 1h4.4v3.4l3.6-3.2.3-.3H20c.6 0 1-.5 1-1V2c0-.5-.5-1-1.1-1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#010101",
  d: "M19.9 0H2C.9 0 0 .9 0 2v11.3c0 1.1.9 2 2 2h3.4v4.6l5.2-4.6h9.3c1.1 0 2-.9 2-2V2c.1-1.1-.8-2-2-2zM21 13.3c0 .6-.5 1-1 1H10.3l-.3.3-3.6 3.2v-3.4H2c-.6 0-1-.5-1-1V2c0-.6.5-1 1-1h17.9c.6 0 1 .5 1 1v11.3z"
})));
export default SvgIconText;